import { render } from "./RoleDrawer.vue?vue&type=template&id=d9529758"
import script from "./RoleDrawer.vue?vue&type=script&lang=js"
export * from "./RoleDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__